import React, { useCallback, useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TableContainer from "@mui/material/TableContainer";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";

import DialogBox from "../../common/DialogBox";
import TileCompanyForm from "./TileCompanyForm";
import DeleteModal from "../../common/DeleteModal";
import { DEFAULT_URL } from "../../helpers/constants";
import SettingsIconSVG from "../../common/SettingsIconSVG";
import ViewIconSVG from "../../common/customSVGs/ViewIconSVG";
import PlainAlertMessage from "../../common/PlainAlertMessage";
import TableHeaderForSorting from "../../common/TableHeaderForSorting";
import { getLocalFormatedDate, getObjLength } from "../../helpers/utils";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";
import CustomPagination from "../../common/customDesignedComponents/CustomPagination";
import { professionalAction } from "../../../redux/slices/admin/professionals/professionalsSlice";
import { propertyUsersAction } from "../../../redux/slices/admin/propertyUsers/propertyUsersSlice";

const TitleCompanyListTable = ({
  handleViewRepresentativeBtn = () => {},
  setSelectedRow = () => {},
  apiCall = () => {},
  isInternalAdmin = false,
  selectedRow = {},
  columns = [],
}) => {
  const dispatch = useDispatch();

  const { titleCompanyListData } = useSelector((state) => state.professionals);
  const { companyDetails, isAddBtnClicked } = useSelector(
    (state) => state?.agentsAdmin
  );
  const { deletePropertyData, deletePropertyLoader } = useSelector(
    (state) => state?.propertyUsers
  );

  // const [columnsArr, setColumnsArr] = useState(columns);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [payload, setPayload] = useState({
    limit: 10,
    offset: 0,
  });
  const [selectedAdminData, setSelectedAdminData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isUpdateCompanyModal, setIsUpdateCompanyModal] = useState(false);
  const [deletePropetyModal, setDeletePropetyModal] = useState(false);

  const rowsData = titleCompanyListData?.success
    ? titleCompanyListData?.data
    : [];
  const PER_PAGE = 10;
  const open = Boolean(anchorEl);

  const handleMenuClick = (event, data) => {
    setSelectedRow(data);
    setSelectedAdminData(data);
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = (e, p) => {
    setPage(p);
    setPayload((prevState) => ({
      ...prevState,
      offset: (p - 1) * PER_PAGE,
    }));
  };

  const handleFormModalClose = () => {
    setIsUpdateCompanyModal(false);
    setSelectedAdminData({});
    dispatch(agentsAdminAction.fetchUpdateCompanyDetailsData({}));
    dispatch(agentsAdminAction.fetchIsAddBtnClicked(false));
    if (getObjLength(companyDetails) && companyDetails?.success) {
      setPage(1);
      if (isInternalAdmin) {
        internalAdminListAPICall();
      } else {
        apiCall();
      }
    }
  };

  const handleDeleteProeprtyOption = (type = false) => {
    setDeletePropetyModal(type);
    dispatch(propertyUsersAction.clearDeletePropertyData({}));
  };

  const handleDeleteProeprty = () => {
    let data = {};
    if (selectedAdminData?.id) {
      dispatch(
        propertyUsersAction.getDeletePropertyData({
          url: `broker/delete-affiliate-admin/${selectedAdminData?.id}`,
          data: {},
          token: true,
          type: "delete",
        })
      );
    }
  };

  const updateCompanyDetails = (values) => {
    let url = `admin/broker/edit/${selectedRow?.id}`;
    let data = values;
    if (isInternalAdmin) {
      if (isAddBtnClicked) {
        // for create admin
        url = `broker/create-affiliate-admin`;
        data = { ...data, broker_id: selectedRow?.id };
      } else {
        url = `broker/edit-affiliate-admin/${selectedAdminData?.id}`;
      }
    }
    dispatch(
      agentsAdminAction.updateCompanyDetails({
        url,
        data,
        token: true,
      })
    );
  };

  const internalAdminListAPICall = useCallback(() => {
    let data = {
      limit: payload?.limit,
      offset: payload?.offset,
      broker_id: selectedRow?.id,
    };
    dispatch(
      professionalAction?.getTitleCompanyListData({
        url: `broker/get-affiliate-admins`,
        data,
        token: true,
      })
    );
  }, [dispatch, payload?.limit, payload?.offset]);

  useEffect(() => {
    if (isInternalAdmin) {
      internalAdminListAPICall();
    }
  }, [isInternalAdmin, internalAdminListAPICall]);

  useEffect(() => {
    if (getObjLength(titleCompanyListData)) {
      if (titleCompanyListData?.success) {
        setPageCount(Math.ceil(titleCompanyListData?.count / PER_PAGE));

        if (titleCompanyListData?.count === 10) {
          setPayload((prevState) => ({
            ...prevState,
            offset: 0,
          }));
        }
      }
    }
  }, [titleCompanyListData]);

  useEffect(() => {
    if (isAddBtnClicked) {
      setIsUpdateCompanyModal(true);
    }
  }, [isAddBtnClicked]);

  return (
    <Box sx={{ width: "100%" }} className={!isInternalAdmin && "mt-5"}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            stickyHeader
          >
            <TableHeaderForSorting
              columns={columns}
              //   handleSorting={handleSorting}
              //   directionFlow={directionFlow}
              //   setSelectedColumn={setSelectedColumn}
              //   selectedColumn={selectedColumn}
            />
            <TableBody>
              {rowsData?.map((row, index) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.address}
                  >
                    <TableCell align="left">
                      {payload?.offset + index + 1}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span
                        className={`title_company-logo ${
                          isInternalAdmin && "internal-admin-scale"
                        }`}
                      >
                        <Avatar
                          src={!isInternalAdmin ? row?.logo : row?.profile_img}
                          className="title_company_logo"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left" className="text-capitalize">
                      {row?.full_name || "-"}
                    </TableCell>
                    <TableCell align="left">{row?.email || "-"}</TableCell>
                    {/* <TableCell align="left">{row?.phone || "-"}</TableCell> */}

                    <TableCell align="left">
                      {row?.created_at
                        ? getLocalFormatedDate(row?.created_at)
                        : "-"}
                    </TableCell>
                    <TableCell align="left">
                      {row?.created_at
                        ? getLocalFormatedDate(row?.updated_at)
                        : "-"}
                    </TableCell>
                    {!isInternalAdmin && (
                      <TableCell align="left">
                        <Tooltip
                          title={`Copy ${row?.first_name} Homepage Link`}
                          TransitionComponent={Zoom}
                          placement="top"
                          arrow
                        >
                          <IconButton
                            sx={{
                              color: "#0395FF",
                              fontSize: "1.4rem",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(
                                DEFAULT_URL + row?.source + "/" + row?.domain
                              );
                            }}
                          >
                            <ContentCopyIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    )}
                    <TableCell align="left">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <IconButton
                          onClick={(e) => handleMenuClick(e, row)}
                          size="small"
                          className="settings-button"
                          aria-controls={open ? "settings-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                        >
                          <SettingsIconSVG />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {!rowsData.length > 0 && (
            <Typography className="p-5 text-center" variant="h6">
              No Data Found.
            </Typography>
          )}
        </TableContainer>
      </Paper>

      <Menu
        // key={index}
        anchorEl={anchorEl}
        id="settings-menu"
        open={open}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
      >
        {!isInternalAdmin && (
          <MenuItem
            key="view"
            onClick={() => handleViewRepresentativeBtn(selectedRow)}
            className="setting-menu-item"
          >
            <Box className="setting-menu-box">
              <ViewIconSVG />
              <Typography className="setting-menu-text">
                View Details
              </Typography>
            </Box>
          </MenuItem>
        )}
        <MenuItem
          key="view"
          onClick={() => setIsUpdateCompanyModal(true)}
          className="setting-menu-item"
        >
          <Box className="setting-menu-box">
            <EditIcon />
            <Typography className="setting-menu-text">
              {isInternalAdmin ? "Edit Admin Details" : "Edit Company Details"}
            </Typography>
          </Box>
        </MenuItem>
        {isInternalAdmin && (
          <>
            {" "}
            <MenuItem
              key="view"
              onClick={() => handleDeleteProeprtyOption(true)}
              className="setting-menu-item"
            >
              <Box className="setting-menu-box">
                <DeleteIcon />
                <Typography className="setting-menu-text">
                  Delete Admin
                </Typography>
              </Box>
            </MenuItem>
          </>
        )}
      </Menu>
      {pageCount > 1 && (
        <Box id="pagination-container">
          <CustomPagination
            count={pageCount}
            page={page}
            handlePageChange={handlePageChange}
          />
        </Box>
      )}

      {/* Add/upldate compnay or internal admin form modal */}
      {isUpdateCompanyModal && (
        <DialogBox
          dividers
          width={
            getObjLength(companyDetails) && companyDetails?.success
              ? "sm"
              : "md"
          }
          title={
            getObjLength(companyDetails) && companyDetails?.success
              ? null
              : isAddBtnClicked
              ? "Add Admin Details"
              : "Edit Company Details"
          }
          contentClassName={"bg-white p-0"}
          openPopup={isUpdateCompanyModal}
          setOpenPopup={setIsUpdateCompanyModal}
          onClose={handleFormModalClose}
          content={
            !getObjLength(companyDetails) || !companyDetails?.success ? (
              <TileCompanyForm
                selectedRow={
                  isAddBtnClicked
                    ? {}
                    : isInternalAdmin
                    ? selectedAdminData
                    : selectedRow
                }
                isInternalAdmin={isInternalAdmin}
                updateCompanyDetails={updateCompanyDetails}
                handleFormModalClose={handleFormModalClose}
              />
            ) : (
              <PlainAlertMessage
                type="Success"
                openPopup={true}
                onClose={true}
                onCloseFun={handleFormModalClose}
                message={companyDetails?.message}
                footer={false}
              />
            )
          }
        />
      )}

      {/* Delete Record */}
      {deletePropetyModal && (
        <DeleteModal
          open={deletePropetyModal}
          title="Delete Property"
          item="Property"
          deleteLoader={deletePropertyLoader}
          handleClose={() => handleDeleteProeprtyOption(false)}
          handleDeleteBtn={handleDeleteProeprty}
          fetchedData={deletePropertyData}
          isDeleteSuccess={deletePropertyData?.success}
          successMessage={deletePropertyData?.message}
          errorMessage={deletePropertyData?.data?.message}
          callListingAPI={internalAdminListAPICall}
          customeMessage={
            <>
              Are you sure you want to delete{" "}
              <b>{selectedAdminData?.full_name}</b> admin? This action can not
              be undone.
            </>
          }
        />
      )}
    </Box>
  );
};

export default TitleCompanyListTable;
